import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-hybridEnergyCabinet",
  "use": "dv-hybridEnergyCabinet-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"dv-hybridEnergyCabinet\"><defs><style>#dv-hybridEnergyCabinet .cls-1{fill:#fff1de;fill-opacity:0}</style></defs><title>组 2486</title><g id=\"dv-hybridEnergyCabinet_图层_2\" data-name=\"图层 2\"><g id=\"dv-hybridEnergyCabinet_图层_1-2\" data-name=\"图层 1\"><g id=\"dv-hybridEnergyCabinet_组_2486\" data-name=\"组 2486\"><path id=\"dv-hybridEnergyCabinet_矩形_278\" data-name=\"矩形 278\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><path id=\"dv-hybridEnergyCabinet_路径_1258\" data-name=\"路径 1258\" d=\"M4.77 1.63A1.17 1.17 0 0 0 3.6 2.8v17.44a1.17 1.17 0 0 0 1.17 1.17h1.48V22a.64.64 0 0 0 .64.65H8a.65.65 0 0 0 .68-.65v-.57h2.72V1.63zm5.76 11.11a.83.83 0 0 1-1.66 0v-2.46a.83.83 0 0 1 1.66 0zm2.2-11.11v19.78h2.72V22a.65.65 0 0 0 .64.65h1.15a.64.64 0 0 0 .64-.65v-.57h1.48a1.17 1.17 0 0 0 1.17-1.17V2.8a1.17 1.17 0 0 0-1.17-1.17zm.87 8.65a.83.83 0 0 1 1.66 0v2.46a.83.83 0 0 1-1.66 0z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-hybridEnergyCabinet.svg
// module id = UqHQ
// module chunks = 6